import { useContext } from "react"
import { Chip, Chips as ChipsGroup, ChipsContainer } from "../../../components/chips/Chips";
import { FeatureContext } from "../../../Context"
import { formatDate } from '../../../Utils';

const Chips = () => {
  const context = useContext(FeatureContext);
  return <ChipsContainer>
    {(!!context.filters.startDate && !!context.filters.endDate) ?
      <ChipsGroup>
        <Chip>{formatDate(context.filters.startDate)} - {formatDate(context.filters.endDate)}</Chip>
      </ChipsGroup> : null}
    {(!!context.filters.status) ?
      <ChipsGroup>
        {context.filters.status.map(value => <Chip
          onClick={() => context.removeFilters('status', value.value)}
          cancelable={true}>{value.label}</Chip>)}
      </ChipsGroup> : null}
    {(!!context.filters.salesOrderNumber) ?
      <ChipsGroup>
        {context.filters.salesOrderNumber.map(value => <Chip
          onClick={() => context.removeFilters('salesOrderNumber', value.value)}
          cancelable={true}>{value.label}</Chip>)}
      </ChipsGroup> : null}
    {(!!context.filters.purchaseOrderNumber) ?
      <ChipsGroup>
        {context.filters.purchaseOrderNumber.map(value => <Chip
          onClick={() => context.removeFilters('purchaseOrderNumber', value.value)}
          cancelable={true}>{value.label}</Chip>)}
      </ChipsGroup> : null}
  </ChipsContainer>
}

export default Chips;